import buildFormReducer from 'reducers/builders/form';
import actionTypes, { actionTypeSections } from 'actiontypes/';
import { combineReducers } from 'redux';

const mainInitialState = {
  isRequesting: false,
};

const formInitialState = {
  email: {
    value: '',
    isValid: false,
    isValidating: false,
  },
};

function mainReducer(state = mainInitialState, action) {
  const actionType = action.type;

  switch (actionType) {
    case actionTypes.FORGOT_PASSWORD_REQUEST.RESET_STATE:
      return { ...mainInitialState };
    case actionTypes.FORGOT_PASSWORD_REQUEST.REQUEST_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        isRequesting: true,
      };
    case actionTypes.FORGOT_PASSWORD_REQUEST.REQUEST_RESET_PASSWORD_SUCCESS:
    case actionTypes.FORGOT_PASSWORD_REQUEST.REQUEST_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        isRequesting: false,
      };
    default:
      return state;
  }
}

const requestReducer = combineReducers({
  main: mainReducer,
  form: buildFormReducer(formInitialState, actionTypeSections.FORGOT_PASSWORD_REQUEST),
});

export { requestReducer as default };
